import { render, staticRenderFns } from "./payToken-authorization.vue?vue&type=template&id=2b44824c&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./payToken-authorization.vue?vue&type=script&lang=js"
export * from "./payToken-authorization.vue?vue&type=script&lang=js"
import style0 from "./payToken-authorization.vue?vue&type=style&index=0&id=2b44824c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b44824c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b44824c')) {
      api.createRecord('2b44824c', component.options)
    } else {
      api.reload('2b44824c', component.options)
    }
    module.hot.accept("./payToken-authorization.vue?vue&type=template&id=2b44824c&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml", function () {
      api.rerender('2b44824c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/directDebit/payToken-authorization.vue"
export default component.exports